export default __webpack_public_path__ + "static/media/peter.6755bc3f.jpg";